import { gql } from '@apollo/client/core';
import { useMutation } from '@vue/apollo-composable';
import { updateLicenses } from '@spectee/graphql/mutations';

const document = gql(updateLicenses);

export function useUpdateLicenses() {
  return useMutation(document);
}
